export { default as Truncate } from './component';
export { default as useTruncate } from './hook';